import { WidgetStrategyWithStreamByRequestUid } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import {
    CandlestickTileConfigState,
    initialCandlestickTileConfigState,
} from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { CandlestickTile } from 'widgets/candlestickTile/components/CandlestickTile';
import { candlestickTileWidgetStreamConfig } from 'widgets/candlestickTile/store/stream/stream-config';
import { candlestickTileDescription } from 'widgets/candlestickTile/components/description/candlestickTileDescription';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import CandlestickTileSettings from 'widgets/candlestickTile/components/settings/CandlestickTileSettings';
import { CandlestickTileMyPortfolioCapsuleContent } from 'widgets/candlestickTile/components/CandlestickTileMyPortfolioCapsuleContent';
import { CandlestickTileStreamRequest } from 'widgets/candlestickTile/api/CandlestickTileStreamRequest';
import { useCandlestickMessagesInMyPortfolioCapsules } from 'widgets/candlestickTile/components/useCandlestickMessagesInMyPortfolioCapsules';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

const useMessagesInMyPortfolioCapsules = (
    symbol: string,
    symbology: SymbologyValues
) => useCandlestickMessagesInMyPortfolioCapsules(symbol, symbology);

export const candlestickTileWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<CandlestickTileConfigState> &
    WidgetStrategyWithStreamByRequestUid<CandlestickTileStreamRequest> = {
    title: 'Candlestick',
    supportedHosts: ['tile'],
    reactComponentType: CandlestickTile,
    myPortfolioCapsuleContentReactComponentType:
        CandlestickTileMyPortfolioCapsuleContent,

    categories: [WidgetCategory.PRICE_CAPSULES],
    description: candlestickTileDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
    initialConfigState: initialCandlestickTileConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    renderSettingsBody,
    managedStreamConfig: candlestickTileWidgetStreamConfig,
    useMessagesInMyPortfolioCapsules,
};

function renderSettingsBody(
    config: CandlestickTileConfigState,
    onChange: (configDelta: Partial<CandlestickTileConfigState>) => void
) {
    return <CandlestickTileSettings config={config} onChange={onChange} />;
}
